import { render } from "./LoginCrm.vue?vue&type=template&id=fa2a923a&scoped=true"
import script from "./LoginCrm.vue?vue&type=script&lang=js"
export * from "./LoginCrm.vue?vue&type=script&lang=js"

import "./LoginCrm.vue?vue&type=style&index=0&id=fa2a923a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2a923a"]])

export default __exports__